// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3OsgM","emails":"CreateEditClinics_emails__276JB","emailTagLabel":"CreateEditClinics_emailTagLabel__1E3uU"};